<template>
  <div>
    <button class="btnAction btn_link">
      <span>VITESSE</span>
      <svg width="10" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.175.5L5 4.827 8.825.5 10 1.832 5 7.5 0 1.832 1.175.5z"
          fill="#313131"
        ></path>
      </svg>
    </button>
    <div class="card smallCard">
      <div class="RateSection my-10">
        <button
          v-for="(rate, index) in playbackRates"
          :key="index"
          class="rateBtn card_btn"
          :class="{ active: index == activeRate }"
          v-on:click="changeRate(index)"
        >
          <span> x{{ rate }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RateSection",
  components: {},
  props: {
    player: {
      type: Object,
    },
    currentRateIndex: {
      type: Function,
    },
  },
  data() {
    return {
      playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
      activeRate: 3,
      changeRate: (i) => {
        this.activeRate = i;
        this.currentRateIndex(i);
        this.player.playbackRate(this.playbackRates[i]);
      },
    };
  },
  mounted(){
    this.activeRate = this.currentRateIndex();
  }
};
</script>

<style>
.RateSection {
  display: flex;
  justify-content: space-around;
}

.RateSection .rateBtn {
  margin: 0 10px;
  cursor: pointer;
  font-family: "Open Sans";
}

@media screen and (max-width: 576px) {
  .RateSection .rateBtn {
    margin: 0px 0px;
  }
}
</style>